import { all, fork } from 'redux-saga/effects';
import initialDataSaga from '../app-root/sagas/initial-data-saga';

export default function* root() {
  yield all([
    fork(initialDataSaga),
  ]);
}
